import { v4 as uuidv4 } from 'uuid';

export const generateNewDeviceToken = (): string => {
  return uuidv4();
};
